import React, { Component } from 'react';
import Instruction from './Instruction';
import Form from './Form';
import '../../assets/scss/style.scss';

import { useQuery } from '@apollo/client';
import { USER_PROFILE } from '../../queries';

const RegisterWorkshopContainer = () => {
    const userProfile = useQuery(USER_PROFILE);


    return (<RegisterWorkshop
        profile={userProfile.data?.profile}/>)
}

class RegisterWorkshop extends Component {
    constructor(props) {
        super(props);
        this.state = {step:0};


        this.stepsText = [
            {
                main:`Step 1`,
                desc:'Requirement'
            },
            {
                main:'Step 2',
                desc:'Register to Workshop'
            }
        ]
        this.step = this.step.bind(this);
        this.nextStep = this.nextStep.bind(this);
    }

    nextStep() {
        this.setState({step: this.state.step+1});
    }

    step(elm, index) {
        const active = this.state.step === index;
        if (active)
            return (
                <div
                    href="#"
                    className="card card-regist-event p-3"
                    key={index}>
                    <p className="font-weight-bold">{elm.main}</p>
                    <p className="mt-0">{elm.desc}</p>
                </div>
            )
        else
            return (
                <div
                    onClick={(e) => this.setState({step:index})}
                    className="btn text-left card card-regist-event p-3 regist-event-inactive"
                    key={index}>
                    <p className="font-weight-bold">{elm.main}</p>
                    <p className="mt-0">{elm.desc}</p>
                </div>
            )
    }

    render() {
        return (
            <div>
                <div className="container mt-5 mb-5">
                    <div className="row">
                        <div className="col-md-6">
                            <h3>Registration</h3>
                            <p>Please follow the steps below</p>
                            <div>
                                {this.stepsText.map(this.step)}
                            </div>
                        </div>
                        <div className="col-md-6">
                            {this.state.step === 0 ?
                                <Instruction
                                    type={this.props.profile?.schoolType}
                                    nextStep={this.nextStep}/> :
                            this.state.step === 1 ?
                                <Form
                                    username={this.props.profile?.username}
                                    schoolType={this.props.profile?.schoolType} /> :
                            <></>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RegisterWorkshopContainer;
